<template>
    <a v-if="$route.path !== route" class="group w-1/3 no-underline mb-4" :href="url" @click="navigate">
        <span
            class="group-hover:bg-primary w-20 h-20 sm:w-24 sm:h-24 rounded-lg bg-app flex justify-center items-center mb-2 relative mx-auto">
            <i :class="icon" class="text-white text-4xl"></i>
            <span
                class="h-6 flex -mt-2 -mr-2 absolute pin-t pin-r items-center justify-center bg-secondary text-white rounded-full text-sm px-2"
                v-if="badge"
                v-text="badge">
            </span>
        </span>
        <span class="block text-xs text-center no-underline text-blue font-heading font-bold uppercase leading-normal"
              v-text="label">
        </span>
    </a>
</template>

<script>
export default {
    props: {
        label: String,
        icon: String,
        badge: Number,
        click: {
            default() {
                return false
            }
        },
        route: {
            default() {
                return null
            }
        },
        url: {
            default() {
                return '#'
            }
        }
    },

    methods: {
        navigate(e) {
            if (this.route) {
                e.preventDefault()
                this.$router.push(this.route)
                this.$emit('navigate', this.route)
            }
        }
    }
}
</script>

<style>
.app-gradient {
    background: url('../assets/gradients/1.jpg');
    background-size: cover;
}
</style>
